import { MutationTree } from 'vuex';
import { CateringPackage, CateringRecommendationRequest } from '@/types/cateringBot';
import { CateringBotState } from '../types';

export const mutations: MutationTree<CateringBotState> = {
	SET_ENABLED(state, value: boolean) {
		state.enabled = value;
	},
	SET_RESULTS(state, payload: { input: CateringRecommendationRequest; results: CateringPackage[] }) {
		state.lastInput = payload.input;
		state.lastResults = payload.results;
	},
	PREPEND_REFINEMENT(state, refined: CateringPackage) {
		if (!state.lastResults) {
			return;
		}
		state.lastResults = [{ ...refined, is_refined: true }, ...state.lastResults];
	},
	SET_REFINING_INDEX(state, index: number | null) {
		state.refiningIndex = index;
	}
};
